function parseProfileDate(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const text = String(value).trim();
  if (/^[1-9]\d{3}$/.test(text)) return { year: Number(text), month: null, day: null, value: text };

  const iso = text.match(/^([1-9]\d{3})-(\d{2})-(\d{2})$/);
  const czech = text.match(/^(\d{1,2})\.\s*(\d{1,2})\.\s*([1-9]\d{3})$/);
  if (!iso && !czech) return null;
  const [year, month, day] = iso ? iso.slice(1).map(Number) : [Number(czech[3]), Number(czech[2]), Number(czech[1])];
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (month < 1 || month > 12 || day < 1 || day > days[month - 1]) return null;
  return { year, month, day, value: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}` };
}

function formatProfileDate(value, yearOnly = false) {
  const date = parseProfileDate(value);
  if (!date) return '';
  return yearOnly || !date.month ? String(date.year) : `${date.day}. ${date.month}. ${date.year}`;
}

module.exports = { parseProfileDate, formatProfileDate };
